import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../store/rootDuck';
import { useDefineUserRole } from './useDefineUserRole';
import { actions as categoriesActions } from '../store/ducks/categories.duck';
import { getFullCategories } from '../crud/categories.crud';
import { ICategoryItem } from '../pages/home/categories/interfaces';

export const useFetchCatalogCategories = () => {
  const dispatch = useDispatch();
  const isAuthorized = useSelector((state: IAppState) => state.auth.user != null);
  const { me, loadingMe } = useSelector((store: IAppState) => ({
    me: store.profile.me,
    loadingMe: store.profile.loading,
  }));
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER', 'ROLE_BUYER_STAFF']);
  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);
  const isManager = useDefineUserRole(me, ['ROLE_MANAGER']);
  const [companyCategories, setCompanyCategories] = useState<ICategoryItem[]>([]);

  const fetchCatalogCategories = (payload: {
    with_products?: boolean;
    company_id?: number;
    only_active?: number;
  }) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { with_products, only_active, company_id } = payload;
    if (!isAuthorized) {
      dispatch(
        categoriesActions.fetchCatalogCategories({
          with_products,
          only_active,
          company_id,
        })
      );
    } else {
      if (loadingMe) return;
      if (!isBuyer && !isVendor && !isManager && !me?.is_admin) return;
      dispatch(
        categoriesActions.fetchCatalogCategories({
          with_products,
          only_active,
          company_id,
        })
      );
    }
  };

  const fetchCatalogCategoriesCompany = (payload: {
    with_products?: boolean;
    company_id?: number;
    only_active?: number;
  }) => {
    getFullCategories(payload).then(({ data }) => setCompanyCategories(data.data));
  };

  return { fetchCatalogCategories, fetchCatalogCategoriesCompany, companyCategories };
};
